export default __webpack_public_path__ + "static/media/18plus.c48022a6.svg";